import React, { useState } from "react";
import {
  Dates, ImagesWrapper, StyledText,
  Wrapper
} from "./paragraph.styles";
import formatedDate from "utils/formatedDate";
import ImageList from "../../editor/ImageUploader/imageList";
import FullscreenImagesViewer from "../FullscreenImagesViewer/fullscreenImagesViewer";
import { IParagraph } from "models/wall";

export default function Paragraph({paragraph}: {paragraph: IParagraph}) {
  const mediaList = paragraph.media;
  const [viewerOpen, setViewerOpen] = useState(false);
  const [initialIndex, setInitialIndex] = useState(0);

  const handleImageClick = (uuid: string) => {
    const index = mediaList?.findIndex(m => m.uuid === uuid);
    if (index === undefined || index < 0) return;
    setInitialIndex(index);
    setViewerOpen(true);
  };

  const fromDate = formatedDate(paragraph.date_from_year, paragraph.date_from_month, paragraph.date_from_day);
  const toDate = formatedDate(paragraph.date_to_year, paragraph.date_to_month, paragraph.date_to_day);

  return (
    <Wrapper>
      {(fromDate || toDate) && (
        <Dates>
          {fromDate}
          {fromDate && toDate && " - "}
          {toDate}
        </Dates>
      )}
      {paragraph.type === 'media' && mediaList && (
        <>
          <ImagesWrapper>
            <ImageList images={mediaList} hideDelete onClick={handleImageClick} />
          </ImagesWrapper>
          {viewerOpen && (
            <FullscreenImagesViewer
              images={mediaList.map(m => m.file as string)}
              initialIndex={initialIndex}
              onClose={() => setViewerOpen(false)}
              text={paragraph.text}
            />
          )}
        </>
      )}
      {paragraph.text && <StyledText isImageCaption={paragraph.type === 'media' && !!mediaList}>{paragraph.text}</StyledText>}
    </Wrapper>
  );
};
